import {
  CLEAR_ACTIVE_FLIGHT,
  SET_ACTIVE_FLIGHT,
  UPDATE_ACTIVE_FLIGHT,
  UPDATE_FLIGHT_LIST,
} from 'actions';

export function activeFlight(state = {}, action) {
  switch (action.type) {
    case SET_ACTIVE_FLIGHT:
    case UPDATE_ACTIVE_FLIGHT:
      return action.activeFlight;
    case CLEAR_ACTIVE_FLIGHT:
      return null;
    default:
      return state;
  }
}

export function flightList(state = [], action) {
  switch (action.type) {
    case UPDATE_FLIGHT_LIST:
      // extract the updated flight list from action
      // this is the collection of new / updated flights
      const { flightList: updatedFlightList } = action;

      let currentState =
        state && Array.isArray(state) && state.length ? [...state] : [];

      for (let i = 0; i < currentState.length; i += 1) {
        const currentFlight = currentState[i];
        const updatedFlightIndex = updatedFlightList.findIndex(
          (updatedFlight) => {
            return updatedFlight.id === currentFlight.id;
          },
        );

        if (updatedFlightIndex > -1) {
          currentState[i] = updatedFlightList[updatedFlightIndex];
          updatedFlightList.splice(updatedFlightIndex, 1);
        }
      }

      // concat new flights and remove flights that are older than 30 days
      const dt30DaysAgo = Date.now() - 30 * 24 * 60 * 60 * 1000;
      currentState = currentState.concat(updatedFlightList).filter((flight) => {
        return flight.modified > dt30DaysAgo;
      });

      // return the result
      return currentState;
    default:
      return state;
  }
}
